import { render } from "./SubjectView.vue?vue&type=template&id=43821e92&scoped=true"
import script from "./SubjectView.vue?vue&type=script&lang=js"
export * from "./SubjectView.vue?vue&type=script&lang=js"

import "./SubjectView.vue?vue&type=style&index=0&id=43821e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43821e92"]])

export default __exports__